import React, { useState, useMemo } from 'react';
import { ArrowUp, ArrowDown, ArrowUpDown } from 'lucide-react';

export function useSort(rows, initialKey = null, initialDir = 'desc') {
  const [sortKey, setSortKey] = useState(initialKey);
  const [sortDir, setSortDir] = useState(initialDir);
  const toggle = (key) => {
    if (sortKey === key) setSortDir(d => (d === 'asc' ? 'desc' : 'asc'));
    else { setSortKey(key); setSortDir('asc'); }
  };
  const set = (key, dir = 'asc') => { setSortKey(key); setSortDir(dir); };
  const sorted = useMemo(() => {
    if (!sortKey) return rows;
    const copy = [...rows];
    copy.sort((a, b) => {
      const av = a[sortKey], bv = b[sortKey];
      if (av == null && bv == null) return 0;
      if (av == null) return 1;
      if (bv == null) return -1;
      if (typeof av === 'number' && typeof bv === 'number') return av - bv;
      if (/^\d{4}-\d{2}/.test(String(av)) && /^\d{4}-\d{2}/.test(String(bv))) {
        return Date.parse(av) - Date.parse(bv);
      }
      return String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
    });
    if (sortDir === 'desc') copy.reverse();
    return copy;
  }, [rows, sortKey, sortDir]);
  return { sorted, sortKey, sortDir, toggle, set };
}

export function SortableTh({ label, sortKey, sort, align = 'left' }) {
  const active = sort.sortKey === sortKey;
  const Icon = active ? (sort.sortDir === 'asc' ? ArrowUp : ArrowDown) : ArrowUpDown;
  return (
    <th className={`py-2.5 px-4 text-[11px] uppercase tracking-wider font-medium select-none ${align === 'right' ? 'text-right' : 'text-left'}`}
      style={{ color: active ? '#1A4C7C' : '#5C6B7A' }}>
      <button type="button" onClick={() => sort.toggle(sortKey)} data-testid={`sort-${sortKey}`}
        className={`inline-flex items-center gap-1 uppercase tracking-wider hover:text-[#0D1B2A] transition-colors ${align === 'right' ? 'flex-row-reverse' : ''}`}>
        {label}<Icon className="w-3 h-3" style={{ opacity: active ? 1 : 0.45 }} />
      </button>
    </th>
  );
}
